const createHybridConfirmationUrl = (reservationId) => {
    let currentUrl = window.location.href;
    let confirmationUrl = `traveler/th/confirmation/hybrid/${reservationId}`;
    let newConfirmationUrl = currentUrl.replace(
        '/td/vc/hybrid/checkoutVasInterstitial',
        `/${confirmationUrl}`
    );
    return newConfirmationUrl;
};
const displayHybridLegacyConfirmation = (reservationId) => {
    window.location.href = createHybridConfirmationUrl(reservationId);
};
export {displayHybridLegacyConfirmation, createHybridConfirmationUrl};
